import { UBI } from '@spotify-internal/ubi-logger-js';
import { createBaseTransport } from '@spotify-internal/transport';
import { createEventSender, Environment } from '@spotify-internal/event-sender';
import { createMrktUBIContextNonAuth } from '@spotify-internal/event-definitions/es5/events/createMrktUBIContextNonAuth';
import {
  createClientIdContext,
  createApplicationContext,
  createCorrelationIdContext,
  createUserAgentContext,
} from '@spotify-internal/event-sender/es5/contexts';
import { getCorrelationId } from './getCorrelationId';

// unauthenticated transport since frodor pages are treated as logged out
const transport = createBaseTransport({
  providers: {
    async endpoints() {
      return {
        webgate: 'https://generic.wg.spotify.com',
        webapi: 'https://api.spotify.com',
      };
    },
    // dummmy token provider since transport should be unauthenticated
    token: () =>
      Promise.reject(new Error('do not call transport.authenticate()')),
  },
});

transport.connect();

const eventSender = createEventSender<Environment.BROWSER_NON_AUTH>({
  transport,
  context: [
    createApplicationContext({ version: '0.0.0' }),
    createClientIdContext('6cf79a93be894c2086b8cbf737e0796b'),
    createUserAgentContext(globalThis.navigator?.userAgent ?? 'unknown'),
    createCorrelationIdContext(getCorrelationId()),
  ],
});

export const ubiLogger = UBI.getUBILogger({
  eventSender: {
    send(event) {
      // send anonymous/unauthed event
      eventSender.send(event, {
        authorize: false,
      });

      // send additional page context event
      if (event.data.page_instance_id) {
        eventSender.send(
          createMrktUBIContextNonAuth({
            ubi_event_id: event.data.page_instance_id,
            page_url: window.location.href,
            title: document.title,
          }),
          { authorize: false },
        );
      }
    },
  },

  authenticationProvider: {
    isAuthenticated() {
      return false;
    },
  },

  // needed so that from_page_instance_id is populated when going between logged-in s4a and frodor
  requiresPersistingState: true,
});
